import { DeleteOutlined, DownOutlined } from '@ant-design/icons';
import { Dropdown, Button, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { type MobilityModuleSpecsFragment } from '../../../../api/fragments/MobilityModuleSpecs';
import { type PermissionValues } from '../../../../utilities/hasPermissions';
import useDeleteModule from '../useDeleteModule';

type MobilityModuleActionsProps = {
    module: MobilityModuleSpecsFragment;
    permissions: Pick<PermissionValues, 'hasDeletePermission'>;
};

const MobilityModuleAction = ({ module, permissions }: MobilityModuleActionsProps) => {
    const { t } = useTranslation(['mobilityModuleDetails']);
    const deleteModule = useDeleteModule(module.id);
    const { hasDeletePermission } = permissions;

    const items = [
        hasDeletePermission && {
            label: t('mobilityModuleDetails:actions.delete'),
            key: 'delete',
            icon: <DeleteOutlined />,
            onClick: deleteModule,
            danger: true,
        },
    ].filter(Boolean);

    if (!items.length) {
        return null;
    }

    return (
        <Dropdown menu={{ items }}>
            <Button type="primary">
                <Space>
                    <span>{t('mobilityModuleDetails:actions.label')}</span>
                    <DownOutlined />
                </Space>
            </Button>
        </Dropdown>
    );
};

export default MobilityModuleAction;
